import React from 'react';
import MesonryGalleryContainer from '../../Componant/Gallery/Mesonry/MesonryGallery';

const MesonryGallery = () => {
  return (
    <div className='page-body'>
      <MesonryGalleryContainer />
    </div>
  );
};

export default MesonryGallery;
